<template id="drilldown-report-page">
    <section>
      <div class="container">
      <!-- <div class="large-12 medium-12 small-12 cell"> -->
                <input type="file" class="form-control input-lg" id="file" ref="file" accept=".xlsx"  v-on:change="handleFileUpload()"/><br />
         <!-- <button v-on:click="submitFile()" class="btn btn-primary me-2" >Upload</button> -->
          <span class="btn btn-primary btn-lg float-left" v-on:click="submitFile()" >Upload <i class="fas fa-upload"></i></span>
      </div>

    </section>
</template>
<script>
import axios from 'axios'

export default {
  name: 'file-upload',
  data: function () {
    return {
      file: ''
    }
  },
  methods: {
     getFileExtension(filename) {
       var test = filename.substring(filename.lastIndexOf('.')+1, filename.length) || filename;
       console.log("extension", test,filename)
      // return filename.split('.').pop();
       return filename.substring(filename.lastIndexOf('.')+1, filename.length) || filename;
},
    submitFile() {
      if (this.file == '') {
        alert("Please Choose a file");
      } else {
        this.checkFileExist(this.file.name);
      }
    },

    resetFile() {
      this.$refs.file.value = '';
    },
    //Handles a change on the file upload
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      console.log("welcome",this.file,this.file.name)
    },

    checkFileExist(fileName) {
      var self=this;
      axios.get(`/api/exists?fileName=${fileName}`)
          .then(function (resp) {
            if (resp.data.exists) {
              if (confirm("File Already Exists, Do you want to overwrite it?")) {
                self.file_load();
              } else {
                self.resetFile();
              }
            } else {
              self.file_load();
            }
          }, function () {
            alert('Error in checking file present status');
          })
    },
    file_load:function() {
      let formData = new FormData();
      formData.append('file', this.file);
      let file_name = this.file.name;
      let file_extn = this.getFileExtension(file_name);
      if ( file_extn != "xlsx") {
        alert('File Extension .' + file_extn + ' Does not allowed, Please choose xlsx file')
      } else {
        axios.post('/api/upload', formData)
            .then(function () {
              console.log('SUCCESS!!');
              alert(file_name + ' Uploaded Successfully!!')
            }, function () {
              console.log('FAILURE!!');
              alert(file_name + ' Upload Failed');

            });

        this.$refs.file.value = '';
      }
    }
  }
}
</script>
<style>
.v-input--selection-controls .v-input__control {
  width: 100%;
}
</style>